import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const konexialConfig: TSPConfig = {
  key: 'konexial',
  name: 'Konexial',
  category: TSPCategory.API_KEY,
  helpText:
    'Enter your Konexial API Key and Carrier ID to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API Key',
          name: 'apikey',
          type: 'text',
          required: true,
        },
        {
          label: 'Carrier ID',
          name: 'carriername',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default konexialConfig;
